<button class="btn btn-secondary btn-animated">
  <div class="loader loader-xs d-inline-block me-1"></div>
  <span>Data is loading...</span>
</button>
<button class="btn btn-secondary btn-animated ms-3" disabled="disabled">
  <div class="loader loader-xs d-inline-block me-1"></div>
  <span>Data is loading...</span>
</button>
